import React, { useState } from 'react';
import { Menu, Drawer, Button, Grid } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

import { menuConfig } from '../utility/menuList';
import { HorizontalMenuWrapper } from './style';

const { useBreakpoint } = Grid;

const TopMenu = ( { darkMode}) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    const location = useLocation();
    const pathName = location.pathname;
    const fullPath = pathName.split('/');

    const currentMenu = menuConfig[fullPath[2]];

    const currentPath = location.pathname.split('/').filter(Boolean).pop();

    if (!currentMenu) return null; // Don't render menu if there's no config

    const matchedKey = currentMenu.find(item => currentPath.startsWith(item.key))?.key || '';
    
    return (
        <HorizontalMenuWrapper darkMode={darkMode}>
            
                {isMobile ? (
                    <>
                        <Button icon={<MenuOutlined />} type="text" onClick={() => setDrawerVisible(true)} style={{ fontSize: 16 }} >  </Button>
                        <Drawer title="Menu" placement="left" onClose={() => setDrawerVisible(false)} open={drawerVisible} >
                            <Menu mode="vertical" selectedKeys={[matchedKey]} items={currentMenu} className="top-menu" style={{ width: '100%' }} onClick={() => setDrawerVisible(false)} />
                        </Drawer>
                    </>
                ) : (
                    <Menu mode="horizontal" selectedKeys={[matchedKey]} items={currentMenu} className="top-menu" style={{ width: '90%' }} />
                )}
            
        </HorizontalMenuWrapper>
    );
};

export default TopMenu;
